import React from "react";
import { Link } from "react-router-dom";

export const HeaderLaptop = ({
  titlePart1,
  titlePart2,
  pageSnippet,
  headerIllustration,
  alt,
}) => {
  return (
    <div className="hidden bg-darkBlue h-full lg:block">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-24">
        <div className="flex items-center justify-between">
          <div className="max-w-lg">
            <h1 className="header1 text-3xl">
              {titlePart1}
              <span className="text-earth">{titlePart2}</span>
            </h1>
            <p className="mt-4 mb-8 text-lightGrey">{pageSnippet}</p>
            <Link
              to="/contact"
              className="bg-earth rounded-md shadow-md py-4 px-8 whitespace-nowrap text-xl font-medium text-white"
            >
              Let's talk
            </Link>
          </div>
          <div>
            <img src={headerIllustration} alt={alt} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const HeaderMobile = ({
  titlePart1,
  titlePart2,
  pageSnippet,
  headerIllustration,
  alt,
}) => {
  return (
    <div className="lg:hidden">
      <div className="bg-darkBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-lg mx-auto text-center pt-12 md:pt-24 pb-56">
            <h1 className="header1 text-3xl">
              {titlePart1}
              <span className="text-earth">{titlePart2}</span>
            </h1>
            <p className="my-8 text-lightGrey text-base md:text-lg">
              {pageSnippet}
            </p>
            <Link
              to="/contact"
              className="bg-earth rounded-md shadow-md py-4 px-8 whitespace-nowrap text-xl font-medium text-white"
            >
              Let's talk
            </Link>
          </div>
        </div>
      </div>
      <div className="">
        <div>
          <div className="-mt-32 flex justify-center">
            <img src={headerIllustration} alt={alt} />
          </div>
        </div>
      </div>
    </div>
  );
};
